import react from "react";


export function buildEmailData({ invoice, account, practice }) {
    const practiceNumber =
      practice?.practiceNumber || invoice?.practice?.practiceNumber || "";

    const patientFirstName =
      invoice?.patient?.patientFirstName || account?.accountFullNames || "";
    const patientLastName =
      invoice?.patient?.patientLastName || account?.accountLastName || "";

    return {
      // used to select finComms template
      practiceNumbers: practiceNumber ? [String(practiceNumber)] : [],

      // practice info
      practiceName:
        practice?.practiceName || invoice?.practice?.practiceName || "",
      practiceEmail:
        practice?.practiceEmail || invoice?.practice?.practiceEmail || "",
      practicePhone:
        practice?.practicePhoneNumber ||
        invoice?.practice?.practicePhoneNumber ||
        "",
      practiceNumber,
      logoURL: practice?.logoURL || invoice?.practice?.logoURL || "",

      // patient
      patientFirstName,
      patientLastName,
      patientName: [patientFirstName, patientLastName]
        .filter(Boolean)
        .join(" "),

      // invoice vars
      invoiceNumber: invoice?.invoiceNumber || "",
      invoiceDate:
        invoice?.invoiceDate ||
        invoice?.invoiceCreatedDate?.slice?.(0, 10) ||
        "",

      // receipt (present in your sample; backend will ignore if type !== "receipt")
      receiptNumber: invoice?.receiptNumber || "",
      receiptDate: invoice?.receiptDate || invoice?.invoiceDate || "",

      // credit note (add if you have them later)
      creditNoteNumber: invoice?.creditNoteNumber || "",
      creditNoteDate: invoice?.creditNoteDate || "",
    };
  }

  